import { get } from 'lodash-es';
import React, { createContext, useCallback, useContext } from 'react';

import type { PropsWithChildren } from 'react';

export type Translations = { [key: string]: string | Translations };

const Context = createContext<Record<string, Translations> | null>(null);

// export const I18nProvider = ({
//   children,
//   translations,
// }: PropsWithChildren<{ translations: Record<string, Translations> }>) => (
//   <Context.Provider value={translations}>{children}</Context.Provider>
// );

export const useI18n = () => {
  const translations = useContext(Context);

  return {
    t: useCallback(
      (
        key: string,
        {
          data = {},
          namespace = 'translations',
        }: { data?: Record<string, unknown>; namespace?: string } = {},
      ) => {
        const translation = get(
          translations?.[namespace] ?? {},
          key,
        )?.toString();

        if (!translation) {
          return `Translation missing for key ${JSON.stringify(key)}`;
        }

        return translation.replace(/\{(.+?)\}/g, (m, key) => {
          const replacement = get(data, key);
          if (typeof replacement !== 'string') return m;

          return replacement;
        });
      },
      [translations],
    ),
  };
};
